// -----------------------------------------------------------------------------
// GLOBAL SITE CONFIG
// -----------------------------------------------------------------------------

let host = 'https://datenbank.apothekenkatalog.at/';
let webHost = 'herba';
let siteTitle = 'Digitaler Apothekenkatalog';


// VOR-PROD (release)
// -----------------------------------------------------------------------------
if (document.location.href.indexOf('mwb.sanodattest.bdata.at') > -1) {

    host = 'https://mwb.sanodattest.bdata.at/';
    siteTitle += ' (VORPROD)';

}
// DEVELOP
// -----------------------------------------------------------------------------
else if (document.location.href.indexOf('mwbdev.sanodattest.bdata.at') > -1) {

    host = 'https://mwbdev.sanodattest.bdata.at/';
    siteTitle += ' (DEV)';

}

// LOCAL ENVIRONMENT (DEV)
// -----------------------------------------------------------------------------
else if(document.location.href.indexOf('localhost') > -1) {

    host = 'https://mwbdev.sanodattest.bdata.at/';
    siteTitle += ' (DEV)';

}


const siteConfig = {
    site: '',
    siteTitle: siteTitle,
    webHost: host + webHost + '/public/',
    cdnHost: host,
    froalaKey: 'lB6C1C1E2uF2C1G1G1A10C1E7A1A5B4htfxlqF-11pysuI-7td1nlcG4gs=='
}


siteConfig.api = siteConfig.webHost + 'api/';
siteConfig.assets = siteConfig.cdnHost + 'assets/';

export { siteConfig };
